export const SEVERITY = {
    CRITICAL: { color: '#ff4d4d', glow: 'rgba(255,77,77,0.7)', chip: 'rgba(255,77,77,0.14)' },
    HIGH: { color: '#ffb020', glow: 'rgba(255,176,32,0.7)', chip: 'rgba(255,176,32,0.14)' },
    MEDIUM: { color: '#00e5ff', glow: 'rgba(0,229,255,0.7)', chip: 'rgba(0,229,255,0.14)' },
    LOW: { color: '#5b7a99', glow: 'rgba(91,122,153,0.7)', chip: 'rgba(91,122,153,0.14)' },
};
/** Display / sort order — most severe first. */
export const SEVERITIES = ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'];
/** Sort weight so critical bubbles to the top of lists. */
export const SEVERITY_WEIGHT = {
    CRITICAL: 0,
    HIGH: 1,
    MEDIUM: 2,
    LOW: 3,
};
export function severityMeta(severity) {
    return SEVERITY[severity];
}
//# sourceMappingURL=severity.js.map